// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__0JZUG","remove-product-button":"remove-product-button__vNUM0"};